import { generateFundCodes, friendlyPurchaseOptionLabel } from "../partials/ais/generate-fund-codes";
import { fundLink } from "../partials/fundLinks";
import { getPrimaryFundId } from "../partials/ais/fund-listing-utils";
import moment from "moment";
import siteLanguage from "../partials/siteLanguage";
import { singleFundIndex } from "../partials/ais/client";

moment.locale(siteLanguage);

export default function () {

	return {
		moment,
		getPrimaryFundId,
		isLoading: false,
		fund: null,

		async fetchFund(fundCode) {
			this.isLoading = true;

			if (!window.fetchedFunds) return

			let matchingFund = null
			for (let i = 0; i < window.fetchedFunds.length; i++) {
				if (window.fetchedFunds[i].fundservCodes.includes(fundCode)) {
					matchingFund = window.fetchedFunds[i];
					break;
				}
			}

			if (!matchingFund) {
				console.warn('matchingFund not found')
				return
			}

			this.fund = generateFundCodes(matchingFund);
			this.isLoading = false;
		},

		fundLink,

		friendlyPurchaseOptionLabel,
	};
}

export function initFundFetch() {

	// event to fire once data is loaded, alpine is listening for this to fire
	// before trying to populate fund details
	const evt = new Event('fundsloaded')
	window.addEventListener('fundsloaded', () => {});
	window.fetchedFunds = [];

	return {
		allFundsById: null,

		async fetchFundsByObjectIds(objectIds) {
			// twig outputs integers instead of strings, let's change that
			const objectIdStrings = objectIds.map((id) => id.toString());

			const response = await singleFundIndex.getObjects(objectIdStrings);
			if (response?.results?.length === 0) {
				console.warn('no results found for those ids');
			}

			window.fetchedFunds = response.results;
			window.dispatchEvent(evt);
		}
	}
}
